import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import Toast, { ToastData } from './Toast';

type ContainerProps = {
    toastList: ToastData[];
    removeToast: (id: string) => void;
};

function ToastContainer({ toastList, removeToast }: ContainerProps) {
    const [list, setList] = useState(toastList);
    useEffect(() => {
        setList([...toastList]);
    }, [toastList]);

    return createPortal(
        <div className="notification-container bottom-right">
            {list.slice(0, 3).map((t) => (
                <Toast {...t} key={t.id} deleteToast={() => removeToast(t.id)} />
            ))}
        </div>,
        document.body
    );
}

export default ToastContainer;
